import { PouchDbRepository } from "../../external";
import StorageHelper from "../../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class UsuariosLocalService {
  static database = "pct-usuarios";
  static databaseEmpresa = null;
  static dbLocalRepository;

  static startSincronizacao(empresaId) {
    if (empresaId && !this.dbLocalRepository) {
      this.databaseEmpresa = `${this.database}-${empresaId}`;
      this.dbLocalRepository = new PouchDbRepository(this.databaseEmpresa);
      this.dbLocalRepository.startSync();
    }
  }

  static stopSincronizacao() {
    if (this.dbLocalRepository) {
      this.dbLocalRepository.stopSync(true);
      this.dbLocalRepository = null;
    }
  }

  static async getByEmail(email) {
    if (!this.dbLocalRepository) {
      return null;
    }
    const result = await this.dbLocalRepository.getAll(
      { email },
      { exatos: ["email"], limite: 1 },
    );
    if (result && result.length > 0) {
      return result[0].dados;
    }
    return null;
  }

  static async deletarDatabase(empresaId) {
    this.startSincronizacao(empresaId);
    await this.dbLocalRepository.deleteDatabase();
    this.dbLocalRepository = null;
    storageHelper.removeLocal(`_pouch_${this.databaseEmpresa}`);
    storageHelper.removeLocal("dados-offline");
    storageHelper.removeLocal("_pouch_check_localstorage");
  }
}
